import { render } from "./Explanation.vue?vue&type=template&id=66aeee11&scoped=true"
import script from "./Explanation.vue?vue&type=script&lang=js"
export * from "./Explanation.vue?vue&type=script&lang=js"

import "./Explanation.vue?vue&type=style&index=0&id=66aeee11&scoped=true&lang=css"

import exportComponent from "/var/www/ca-quiz.staging.mindoza.net/releases/20240705152708/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66aeee11"]])

export default __exports__